import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';
import { useEffect, useState } from 'react';
import {SurveyDetails} from "./BackofficeSurveyDetails.model";

const useBackofficeSurveyDetails = (props: { id: string }) => {
	const { id } = props;
	const { get, put } = useFetchWrapper();

	const [survey, setSurvey] = useState<SurveyDetails>();
	const [surveyResponseLink, setSurveyResponseLink] = useState<string>("");

	useEffect(() => {
		getSurveyDetails();
	}, [id]);
	

	const getSurveyDetails = async () => {
		const response: HttpResponse<SurveyDetails> = await get(`/survey/${id}`);
		if(response.parsedBody) {
			setSurvey(response.parsedBody);
			if(response.parsedBody.responseLink) {
				setSurveyResponseLink(response.parsedBody.responseLink)
			}
		}
	};
	
	const editSurvey = async () => {
		const response = await put(`/survey/${id}`, surveyResponseLink);
		if(response.status === 200) getSurveyDetails()
	};
	

	return {
		editSurvey,
		setSurveyResponseLink,
		state: {
			survey,
			surveyResponseLink,
		},
	};
};
export default useBackofficeSurveyDetails;